import styled from 'styled-components'

export const ListItem = styled.li`
  margin: 8px;
`

export const DirectionButton = styled.button`
  background-color: #ffffff33;
  border: none;
  border-radius: 5px;
  padding: 8px 18px;
  cursor: pointer;
  opacity: ${props => (props.isActive ? 1 : 0.5)};
  color: #ffffff;
  font-weight: 500;
`
